module.exports = __webpack_public_path__ + "images/ba0e8d4.png";